import type { RouteRecordRaw } from 'vue-router'

// Routes of the account area. meta.account: requires a signed-in account.
export const routes: RouteRecordRaw[] = [
  { path: '/me', name: 'account', component: () => import('./IndexView.vue'), meta: { account: true } },
  { path: '/me/profile', name: 'account-profile', component: () => import('./ProfileView.vue'), meta: { account: true } },
  { path: '/me/security', name: 'account-security', component: () => import('./SecurityView.vue'), meta: { account: true } },
  { path: '/me/delete', name: 'account-delete', component: () => import('./DeleteView.vue'), meta: { account: true } },
  { path: '/register', name: 'register', component: () => import('../../views/AuthRoute.vue') },
  { path: '/reset-password', name: 'reset-password', component: () => import('../../views/AuthRoute.vue') },
]
